export default [{
    name: "Kopf nach vorn geneigt",
    key: "forwardhead",
    definition: {
        name: "Definition",
        list: ["Kopf nach vorn geneigt bezieht sich darauf, dass sich der Kopf des Menschen in einer natürlichen Steh- oder Sitzposition in einer ungew?hnlich nach vorn geneigten Position zum Rumpf befindet. Dies ist h?ufig bei lange sitzenden Schülern und Büroangestellten zu beobachten."]
    },
    triggerreason: {
        name: "Die Ursachen",
        list: [
            "1、Langes Bücken beim Arbeiten. Wenn man lange Zeit vor dem Computer arbeitet, neigt der Kopf gewohnheitsm??ig nach vorn.",
            "2、Gewohnheitsm??ig den Kopf senken, um auf das Handy zu schauen. Das Schauen auf das Handy mit gesenktem Kopf, das sogenannte ‘Handy-Kopf-Senker-Tribe’, ist ebenfalls eine der Hauptursachen für die Neigung des Kopfes nach vorn.",
        ]
    },
    danger: {
        name: "Gefahren",
        list: [
            "1. Schwindel und Kopfschmerzen: Die Neigung des Kopfes nach vorn kann die Durchblutung des Kopfes beeintr?chtigen. Durch eine schlechte Durchblutung kommt es zu Sauerstoffmangel im Kopf, was zu Schwindel und Kopfschmerzen führt.",
            "2. Halswirbels?ulenerkrankungen: Durch die fehlgestellte Position des Kopfes kommt es zu Abnormalit?ten in den Weichteilen und Knochen des Halses und erh?ht das Risiko für Halswirbels?ulenerkrankungen.",
            "3. Herz-Kreislauf-Erkrankungen und zerebrovaskul?re Erkrankungen: Die fehlgestellte Position des Kopfes kann die Durchblutung im Kopf beeintr?chtigen und die Gesundheit des Herz-Kreislauf-Systems und des Gehirns gef?hrden.",
        ],
    }
},
{
    key: "lateralhead",
    name: "Seitenneigung des Kopfes",
    definition: {
        name: "Definition",
        list: ["Seitenneigung des Kopfes bezieht sich auf die abnorme Haltung, bei der der Kopf beim natürlichen Stehen oder Sitzen des menschlichen K?rpers überm??ig zu einer Seite geneigt ist. Die Hauptursache ist das Ungleichgewicht der Muskelkraft der Nacken- und Schultermuskeln auf beiden Seiten, meistens verursacht durch gewohnheitsm??ige falsche Haltungen."]
    },
    triggerreason: {
        name: "Ursachen",
        list: [
            "1. Gewohnheitsm??ig die Muskeln des Nackens und der Schulter auf einer Seite verwenden: Beim Sitzen oder Liegen neigt sich der Nacken oft nur in eine Richtung, was zu einem Ungleichgewicht der Muskelkraft des Nackens und der Schultern auf beiden Seiten führt.",
        ]
    },
    danger: {
        name: "Gefahren",
        list: [
            "1. Chronische überlastung von Muskeln und B?ndern: Langes seitliches Neigen des Kopfes kann leicht zu chronischer überlastung der hinteren Halsb?nder sowie der Muskel- und Bandb?nder führen.",
            "2. Halswirbels?ulenerkrankungen: Durch die fehlgestellte Position des Kopfes kommt es zu Abnormalit?ten in den Weichteilen und Knochen des Halses und erh?ht das Risiko für Halswirbels?ulenerkrankungen.",
        ],
    }
},
{
    key: "unevenshoulder",
    name: "ungleich hohe Schultern",
    definition: {
        name: "Definition",
        list: ["ungleich hohe Schultern bezieht sich auf die Situation, in der die Schultern auf beiden Seiten bei natürlicher Entspannung des menschlichen K?rpers unterschiedliche H?hen haben. üblicherweise gehen ungleich hohe Schultern mit Abnormalit?ten in der Haltung der Wirbels?ule einher."]
    },
    triggerreason: {
        name: "Die Ursachen",
        list: [
            "1. überm??ige Belastung auf einer Seite: Zum Beispiel lange Zeit eine Tasche oder schwere Gegenst?nde auf einer Seite tragen.",
            "2. L?ngere Zeit falsche Sitzhaltung: Verursacht durch schlechte Gewohnheiten wie das lange Zeitiges Beinübereinanderschlagen und Sitzen sowie das Anlehnen an den Tisch beim Arbeiten im Sitzen.",
        ]
    },
    danger: {
        name: "Gefahren",
        list: [
            "1. Rückenschmerzen: (ungleich hohe Schultern) k?nnen eine Verschiebung des Beckens verursachen, was zu einem Ungleichgewicht der Muskelkraft auf beiden Seiten der Taille führt und Rückenschmerzen verursacht.",
            "2. Osteophyt: Ungleich hohe Schultern führen zu einer abnormalen Belastung der Halswirbels?ule und k?nnen schlie?lich zu einer Degeneration der Halswirbels?ulenregion führen und leicht Osteophyten bilden.",
        ],
    }
},
{
    key: "roundedshoulder",
    name: "runde Schultern",
    definition: {
        name: "Definition",
        list: ["Runde Schultern beziehen sich auf den Zustand, in dem die Schultern seitlich betrachtet nach vorne und nach innen geneigt erscheinen. Meistens begleitet von Rundrücken. H?ufig bei Schülern und Büroarbeitern."],
    },
    triggerreason: {
        name: "Die Ursachen",
        list: [
            "1. Schlechte Gewohnheitshaltung: wie eingeknickte Schultern und Buckel, unregelm??iges Liegen auf der Seite etc.",
            "2. Muskelkraftungleichgewicht in Brust und Rücken: Die Brustmuskeln sind relativ schw?cher als die Rückenmuskeln.",
        ]
    },
    danger: {
        name: "Gefahren",
        list: [
            "1. Erh?hte Belastung des Herzens: überm??ige runde Schultern führen dazu, dass das Zwerchfell angespannt wird, was zu einer Kompression der Aorta und der Vena cava führt und die Belastung des Herzens erh?ht.",
            "2. Nervenkompression: Die Muskelanspannung um Schultern und Nacken kann in schweren F?llen die Nerven der Halswirbels?ule komprimieren und Kopfschmerzen und Taubheit im Arm verursachen.",
        ],
    }
},
{
    name: "Wirbels?ulenseitverkrümmung",
    key: "scoliosis",
    definition: {
        name: "Definition",
        list: ["Es treten Anomalien in der Wirbels?ulenposition auf. Durch bildgebende Untersuchungen k?nnen nicht gerade Zust?nde der Wirbels?ule wie Wirbels?ulenseitverkrümmung festgestellt werden. Anomalien k?nnen in angeborene und erworbene unterteilt werden. Erworbene Anomalien h?ngen mit fehlerhaften Gewohnheitshaltungen zusammen."],
    },
    triggerreason: {
        name: "Die Ursachen",
        list: [
            "1. überm??ige einseitige Belastung: Zum Beispiel lange Zeit einseitig eine Tasche oder schwere Gegenst?nde tragen.",
            "2. L?ngere Zeit falsche Sitzhaltung: Verursacht durch schlechte Gewohnheiten wie das lange Beinübereinanderschlagen und Sitzen oder das Anlehnen an den Tisch beim Arbeiten im Sitzen.",
            "3. Angeborene Ursachen: Wirbels?ulenseitverkrümmung durch angeborene Faktoren.",
        ]
    },
    danger: {
        name: "Gefahren",
        list: [
            "1. Bandscheibenvorfall in der Lendenwirbels?ule.",
            "2. Rückenschmerzen: Kann zu einer Verschiebung des Beckens führen, wodurch die Muskelkraft auf beiden Seiten der Taille ungleichm??ig wird und Rückenschmerzen verursacht.",
            "3. Unequal length legs.",
        ],
    }
},
{
    name: "Laterale Neigung des Beckens",
    key: "unevenhip",
    definition: {
        name: "Definition",
        list: ["Laterale Neigung des Beckens bezieht sich auf einen Zustand, in dem die H?he der Hüften auf beiden Seiten erheblich unterschiedlich ist und ein schiefes Becken auftritt. Oft begleitet von Anomalien in der Wirbels?ulenposition und ungleichen Schultern."],
    },
    triggerreason: {
        name: "Die Ursachen",
        list: [
            "1. L?ngere Zeit falsche Sitzhaltung: Verursacht durch schlechte Gewohnheiten wie das lange Beinübereinanderschlagen und Sitzen oder das Anlehnen an den Tisch beim Arbeiten im Sitzen.",
            "2. Angeborene Beinl?ngendifferenz: Laterale Neigung des Beckens aufgrund einer angeborenen Beinl?ngendifferenz.",
            "3. Ungleichgewicht der K?rperhaltung der unteren Extremit?ten auf beiden Seiten: Zum Beispiel hat ein Fu? Plattfu?, w?hrend der andere nicht oder der Grad ist unterschiedlich; beide Seiten haben eine überstreckung des Knies, aber der Grad ist unterschiedlich.",
        ]
    },
    danger: {
        name: "Gefahren",
        list: [
            "1. Bandscheibenvorfall in der Lendenwirbels?ule.",
            "2. Chronische Schmerzen: Eine laterale Neigung des Beckens kann zu Schmerzen in der Hüfte, im Bein sowie im Nacken und in den Schultern führen.",
            "3. Unequal length legs.",
        ],
    }
},
{
    name: "O-Bein",
    key: "oleg",
    definition: {
        name: "Definition",
        list: ["Wenn eine Person in normaler Haltung steht und die Fü?e zusammen sind, k?nnen die inneren Kn?chel aneinanderliegen, aber die inneren Knie k?nnen nicht aneinanderliegen und es kann sogar eine gro?e Lücke geben. Zwischen den Beinen erscheint eine O-Form. Diese Art von Beinform ist mit den allt?glichen Haltungsgewohnheiten verbunden. Das Auftreten von O-Beinen bei Kindern kann auch mit Rachitis zusammenh?ngen."],
    },
    triggerreason: {
        name: "Die Ursachen",
        list: [
            "1. Schlechte Haltungsgewohnheiten wie: Rückw?rtsneigung des Beckens und Tendenz zur Fu?pronation.",
            "2. Muskelkraftungleichgewicht wie: zu straffe ?u?ere Hüftrotatorenmuskeln.",
        ]
    },
    danger: {
        name: "Gefahren",
        list: [
            "1. Verletzung des medialen Meniskus: O-Beine führen zu Ver?nderungen in der Kraftlinie der unteren Extremit?ten. Der mediale Gelenkspalt des Knies ist einem Druck ausgesetzt, der gr??er ist als die normale Belastung. Dies kann zu einer Verletzung des medialen Meniskus des Knies führen.",
            "2. Arthritis: Schwere F?lle (O-Beine) k?nnen schlie?lich zu einer Kniegelenks-Osteoarthritis und Gelenkdegeneration im lateralen Gelenkspalt führen. In schweren F?llen kann eine künstliche Gelenkersatzoperation erforderlich sein.",
        ],
    }
},
{
    name: "X-Beine",
    key: "xleg",
    definition: {
        name: "Definition",
        list: "Wenn eine Person in normaler Haltung steht und die Beine zusammen sind, k?nnen die inneren Knie dicht aneinanderliegen, aber die inneren Seiten der Kn?chel k?nnen nicht dicht aneinanderliegen und es kann sogar eine gro?e Lücke geben. Die Form zwischen den Beinen ist wie das \"X\". Diese Art von Beinform h?ngt mit allt?glichen Haltungsgewohnheiten und einem Muskelkraftungleichgewicht zusammen.",
    },
    triggerreason: {
        name: "Die Ursachen",
        list: [
            "1. Gewohnheitsm??ige schlechte Haltung wie: Vorneigung des Beckens, Tendenz zur Fu?abspreizung.",
            "2. Muskelkraftungleichgewicht, wie: zu straffe Hüftinnenrotatoren.",
        ]
    },
    danger: {
        name: "Gefahren",
        list: [
            "1. Verletzung des lateralen Meniskus: X-Beine führen zu Ver?nderungen in der Kraftlinie der unteren Extremit?ten. Der laterale Gelenkspalt des Knies ist einem Druck ausgesetzt, der gr??er ist als die normale Belastung. Dies kann zu einer Verletzung des lateralen Meniskus des Knies führen.",
            "2. Arthritis: Schwere F?lle (X-Beine) k?nnen schlie?lich zu einer Kniegelenks-Osteoarthritis und Gelenkdegeneration im lateralen Gelenkspalt führen. In schweren F?llen kann eine künstliche Gelenkersatzoperation erforderlich sein.",
        ],
    }
},
{
    name: "überstreckung des Knies",
    key: "kneehyperextension",
    definition: {
        name: "Definition",
        list: ["überstreckung des Knies, auch bekannt als 'Knie-Rückbogens'. Von der Seite des menschlichen K?rpers betrachtet, kann man sehen, dass das Bein nach hinten gebogen ist, das Knie eingedellt ist und die Wade im Vergleich zum Oberschenkel überm??ig nach vorne ausgestreckt ist. Diese Haltung ist h?ufig bei Ballettt?nzerinnen und Menschen mit schwacher Muskelkraft im Oberschenkel zu sehen."],
    },
    triggerreason: {
        name: "Die Ursachen",
        list: [
            "1. Falsche Kraftanwendungshaltung: Beim Stehen f?llt das Hauptgewicht auf die Vorfu?spitze.",
            "2. Spannung in der Fu?sohlenfaszie: Kann durch langfristiges Tragen von High Heels verursacht werden.",
            "3. Schwache Muskelkraft um das Knie. Unzureichende Muskelkraft an der Vorder- und Rückseite des Oberschenkels.",
        ]
    },
    danger: {
        name: "Gefahren",
        list: [
            "1. Kniegelenksdeformit?t: Langes Stehen mit überstrecktem Knie kann zu einem deutlichen Anstieg der H?ufigkeit von Gelenkdegeneration führen und zu überm??igem Verschlei? des Kniegelenks führen, was zu einer Gelenkdeformit?t führt.",
            "2. Sch?digung des Gesamtgleichgewichts: Zwischen den drei Gelenken Hüfte, Knie und Kn?chel besteht eine gro?e positional und funktionelle Verbindung. Eine Ver?nderung der Position des Knies wirkt sich auf die Position des Kn?chels darunter und die Position des Hüftgelenks und des Beckens darüber aus und beeintr?chtigt allm?hlich den Gleichgewichtszustand des gesamten K?rpers. Auf lange Sicht kann dies zu verschiedenen Arten von Schmerzen führen.",
        ],
    }
},
]